<template>
    <div class="footer-main">
        <div class="o-container">
            <article>
                <img :src="require(`@/assets/img/${theme}.svg`)" alt="main logo" width="160"/>
                <!-- <div style="width: 400px">
                    <small class="u-display-block" style="font-size: 14px">
                        <span class="u-display-block mb--">
                            © {{ new Date().getFullYear() }} {{copyright}} <br />
                        </span>
                        <div class="o-flex o-flex--start">
                            <svg class="mt-- mr-" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.167 15.167" width="13" style="min-width: 13px;"><g fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.167" data-name="Icon feather-map-pin"><path d="M11.583 6.311c0 4.455-5.5 8.273-5.5 8.273s-5.5-3.818-5.5-8.273a5.617 5.617 0 0 1 5.5-5.728 5.617 5.617 0 0 1 5.5 5.728Z" data-name="Path 24"></path><path d="M7.917 6.31a1.872 1.872 0 0 1-1.834 1.908A1.872 1.872 0 0 1 4.25 6.31a1.872 1.872 0 0 1 1.833-1.909A1.872 1.872 0 0 1 7.917 6.31Z" data-name="Path 25"></path></g></svg>
                            <p class="mb--">
                              {{$t('payment.registered_office')}}. <br>
                              {{$t('payment.trading_address')}}. <br>
                              {{$t('payment.registration')}}
                            </p>
                        </div>
                        This site is protected by reCAPTCHA and the Google
                        <a class="clr-gold" style="font-size: inherit" href="https://policies.google.com/privacy">Privacy Policy</a> and
                        <a class="clr-gold" style="font-size: inherit" href="https://policies.google.com/terms">Terms of Service</a> apply.
                    </small>

                </div> -->
            </article>
            <article style="padding-left: 15px">
                <ul class="link-list">
                  <li><router-link :to="{name: 'privacy'}">{{$t('navigation.footer.privacy')}}</router-link></li>
                  <!-- <li class="divider">|</li> -->
                  <li><router-link :to="{name: 'terms'}">{{$t('navigation.footer.terms')}}</router-link></li>
                  <!-- <li class="divider">|</li> -->
                  <li><router-link :to="{name: 'imprint'}">{{$t('general.imprint.imprint')}}</router-link></li>
                  <!-- <li class="divider">|</li> -->
                  <li><router-link :to="{name: 'PrivacyAndRefundPolicy'}">{{$t('navigation.footer.privacy_and_refund_policy_headline')}}</router-link></li>
                  <!-- <li class="divider">|</li> -->
                  <li><router-link :to="{name: 'SafetyAndAntiScamPolicy'}">{{$t('navigation.footer.safety_and_anti_scam_policy_headline')}}</router-link></li>
                  <!-- <li class="divider">|</li> -->
                  <li><router-link :to="{name: 'CommunityGuidelinesCodeOfConduct'}">{{$t('navigation.footer.community_guidelines_code_of_conduct_headline')}}</router-link></li>
                  <!-- <li class="divider">|</li> -->
                  <li><router-link :to="{name: 'CookiePolicy'}">{{$t('navigation.footer.cookie_policy_headline')}}</router-link></li>
                  <!-- <li class="divider">|</li> -->
                  <li><router-link :to="{name: 'VerificationPrivacy'}">{{$t('navigation.footer.verification_privacy_headline')}}</router-link></li>
                  <!-- <li class="divider">|</li> -->
                  <li><router-link :to="{name: 'anti-slavery'}">{{$t('general.anti_slavery')}}</router-link></li>
                  <!-- <li class="divider">|</li> -->
                  <li><router-link :to="{name: 'ConsentPolicy'}">{{$t('navigation.footer.consent_policy_headline')}}</router-link></li>
                  <!-- <li class="divider">|</li> -->
                  <li><a :href="contactLink" target="_blank">{{$t('general.imprint.contact')}}</a></li>
                </ul>

                <small class="recaptcha-notice" v-if="showRecaptchaNotice">
                    {{ $t('footer.recaptcha.notice') }}
                </small>

              <p class="support-email">{{ supportEmail }}</p>

              <CardBrandLogos v-if="theme === 'luxliebe'" />

              <!-- <ul class="mb0 partners-link">
                    <li><img src="@/assets/img/amazon.svg" alt="amazon"></li>
                    <li><img src="@/assets/img/ssl.svg" alt="ssl"></li>
                    <li><img src="@/assets/img/verified-members.svg" alt="verified"></li>
                    <li><img src="@/assets/img/master.svg" alt="master" width="38"></li>
                    <li><img src="@/assets/img/visa.svg" alt="visa" width="75"></li>
                    <li><img src="@/assets/img/verified-visa.svg" alt="verified-visa" width="53"></li>
                    <li><img src="@/assets/img/MasterCard_SecureCode.webp" alt="MasterCard_SecureCode" width="75"></li>

                </ul> -->
            </article>
        </div>
    </div>
</template>

<script>

import ThemeMixin from "@/mixins/ThemeMixin";
import { supportEmail } from "@/service/support-email";
import { mapGetters } from "vuex";
import CardBrandLogos from '@/components/payment/CardBrandLogos.vue';

export default {
    name: "Footer",
    components: { CardBrandLogos },
    mixins: [ThemeMixin],
    computed: {
        ...mapGetters({
            lang: 'authenticate/language'
        }),
        supportEmail() {
            return supportEmail()
        },
        contactLink() {
            const language = this.lang === 'sr' ? 'rs' : this.lang
            const locale = ['de', 'en', 'it', 'fr', 'es', 'rs'].includes(language)
                ? language
                : 'en'

            if (this.theme === 'luxliebe') {
                return `https://luxliebe.com/${locale}/customer-support`
            }

            if (locale === 'rs') {
                return 'https://sugardaddy.date/sr/korisnicka-podrska-i-naplata/'
            }
            if (locale === 'es') {
                return 'https://sugardaddy.date/es/atencion-al-cliente-y-facturacion/'
            }

            return `https://sugardaddy.date/${locale}/customer-support-${locale}/`
        },
        showRecaptchaNotice() {
            return ['login', 'register'].includes(this.$route.name)
        }
    },
    created() {
        this.copyright = process.env.VUE_APP_COPYRIGHT || 'HALOSAURIDAE LTD, ALL INTELLECTUAL PROPERTY RIGHTS RESERVED'
    }
}
</script>

<style scoped lang="scss">
    .footer-main {
        padding: 30px 0;

    }

    .o-container {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        >article {
            &:first-child {
                display: flex;
                align-items: flex-start;

                img {
                    min-width: 60px;
                    margin-right: 20px;
                }

                small {
                    display: block;
                    max-width: 350px;
                    color: #000000;
                }

                @media(max-width: 480px) {
                    justify-content: center;
                }
            }
            .partners-link {
                display: flex;
                align-items: flex-end;


                li {
                    &:not(:last-child) {
                        margin-right: 10px;
                    }
                }

                @media(max-width: 991px) {
                    flex-wrap: nowrap;
                }

                @media(max-width: 768px) {
                    flex-wrap: wrap;
                }
            }
            .link-list {
                display: flex;
                font-size: 16px;
                color: $color-type7;
                margin-bottom: 10px;
                flex-wrap: wrap;
                gap: 5px 20px;

                @media(max-width: 991px) {
                    flex-wrap: wrap;
                    justify-content: flex-start;
                }

                a {
                    color: $color-credits-type3;
                    font-size: 12px;
                    white-space: nowrap;

                    &:hover {
                        color: $color-type19;
                    }
                }

                @media(max-width: 480px) {
                    justify-content: center;

                }
            }

            .recaptcha-notice {
                display: block;
                max-width: 430px;
                font-size: 12px;
                line-height: 1.35;
                color: $color-credits-type3;

                a {
                    font-size: inherit;
                }

                @media(max-width: 480px) {
                    margin: 0 auto;
                    text-align: center;
                }
            }

            
        }

        .support-email {
            font-size: 12px;
            color: $color-credits-type4;
            margin-top: 10px;
            
            @media(max-width: 480px) {
                text-align: center;
            }
        }
    }

    .divider {
        margin: 0 5px;
        // height: 18px;
        // width: 2px;
        // min-width: 2px;
        // background-color: #000000;
        color: #000;
    }

</style>
